import {inject, Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {OrgDto} from "../dto/org.dto";
import {Observable, tap} from "rxjs";
import {VoidDto} from "../dto/void.dto";
import {UrlBuilder} from "../item/url.item";
import {WrapperDto} from "../dto/wrapper.dto";
import {map} from "rxjs/operators";
import {SearchRequest} from "../dto/search/search-table.dto.req";
import {SearchCatalogRes} from "../dto/search/search-catalog.res";
import {SearchGoodsGroupRes} from "../dto/search/search-goods-group.res";
import {GoodsGroupDto} from "../dto/goods-group.dto";

@Injectable({providedIn: 'root'})
export class GoodsGroupRepo {

  private readonly ggRead = '/v1/org/{orgId}/goods-group/{id}';
  private readonly ggWrite = '/v1/org/{orgId}/goods-group';
  private readonly ggSearch = '/v1/org/{orgId}/goods-group/search';
  private readonly ggDelete = '/v1/org/{orgId}/goods-group/{id}/delete';

  private readonly http: HttpClient = inject(HttpClient);

  public getById(org: OrgDto, id: string): Observable<WrapperDto<GoodsGroupDto>> {
    const url = UrlBuilder.builder().addPath(this.ggRead)
      .addParam('orgId', org.id).addParam('id', id).build();
    return this.http.get<WrapperDto<GoodsGroupDto>>(url.getUrl(), url.getOptions())
      .pipe(map((res) => new WrapperDto(res)));
  }

  public update(org: OrgDto, goodsGroup: GoodsGroupDto): Observable<WrapperDto<GoodsGroupDto>> {
    const url = UrlBuilder.builder().addPath(this.ggWrite).addParam('orgId', org.id).build();
    return this.http.post<WrapperDto<GoodsGroupDto>>(url.getUrl(), goodsGroup, url.getOptions())
      .pipe(map((res) => new WrapperDto(res)));
  }

  public delete(org: OrgDto, id: string): Observable<WrapperDto<VoidDto>> {
    const url = UrlBuilder.builder().addPath(this.ggDelete)
      .addParam('orgId', org.id).addParam('id', id).build();
    return this.http.post<WrapperDto<VoidDto>>(url.getUrl(), {}, url.getOptions())
      .pipe(map((res) => new WrapperDto(res)));
  }

  // ##########################################################################
  // #### Search
  // ##########################################################################

  public search(org: OrgDto, request: SearchRequest): Observable<WrapperDto<SearchGoodsGroupRes>> {
    const url = UrlBuilder.builder().addPath(this.ggSearch).addParam('orgId', org.id).build();
    return this.http.post<WrapperDto<SearchCatalogRes>>(url.getUrl(), request, url.getOptions()).pipe(
      tap((res) => res.dataType = res.dataType === 'SearchResultDto' ? 'SearchGoodsGroupRes' : res.dataType),
      map((res) => new WrapperDto(res))
    );
  }
}
